import { all, fork } from 'redux-saga/effects';
import { carPolicyRenewalSaga } from './CarPolicyRenewal';

export default function* () {
  yield all([
    fork(carPolicyRenewalSaga),
  ]);
}
